import { AUTHENTICATION_CURRENT_USER_ENDPOINT } from '@yme/common/endpoints';
import { buildInitialsProfile } from '@yme/components/Header/helpers';
import { Network } from '@yme/services/network';
export const getUserData = async () => {
    const response = await Network.get(AUTHENTICATION_CURRENT_USER_ENDPOINT);
    const responseProfileData = response.data;
    const initials = buildInitialsProfile(response.data);
    return {
        initials,
        ...responseProfileData,
    };
};
